// TODO (INFL-????) This is the list of actions use in new basket
// We must make sure they continue to be fired after old basket is deprcated
const ACTION_TYPES = {
    SET_RWD_BASKET: 'SET_RWD_BASKET',
    SET_MAIN_BASKET_TYPE: 'SET_MAIN_BASKET_TYPE',
    SET_ROOT_BASKET_TYPE: 'SET_ROOT_BASKET_TYPE',

    // Legacy using
    UPDATE_BASKET: 'UPDATE_BASKET',

    // Legacy remove???
    SET_BASKET_TYPE: 'SET_BASKET_TYPE'
};

const { calculateRootBasketType } = require('utils/RwdBasket');

const initialState = {
    isInitialized: false,
    currentRootBasketType: null,
    currentMainBasketType: null,

    // Legacy
    currentBasketType: null
};

// TODO convert to action - {type, payload}
const reducer = function (state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.SET_RWD_BASKET: {
            return {
                ...state,
                isInitialized: true
            };
        }

        case ACTION_TYPES.UPDATE_BASKET: {
            const { basket } = action;

            return {
                // replace basket state completely to ensure that properties
                // that are not present in latest response are removed from old state
                ...basket,
                ...calculateRootBasketType(basket)
            };
        }

        case ACTION_TYPES.SET_ROOT_BASKET_TYPE: {
            const { currentRootBasketType } = action;

            return {
                ...state,
                currentRootBasketType
            };
        }

        // For buttons/links on PRE_BASKET
        // For SwitchBasket on MAIN_BASKET
        case ACTION_TYPES.SET_MAIN_BASKET_TYPE: {
            const { currentMainBasketType } = action;

            return {
                ...state,
                currentMainBasketType
            };
        }

        // KEEP this as legacy basket type
        // try not to write new code that uses this
        // use this to monitor existing dispatches
        case ACTION_TYPES.SET_BASKET_TYPE: {
            const { currentBasketType } = action;

            return {
                ...state,
                currentBasketType
            };
        }

        // TODO ??? ACTION_TYPES.SHOW_BASKET_ERROR

        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
